export default (entity = {}) => {
    return {
        id: entity.id || undefined,
        restaurantId: entity.restaurantId,
        brand: entity.brand || '',
        hasPrinter: entity.hasPrinter || false,
        languages: entity.languages || ['he'],
        orderOptions: entity.orderOptions || ['sitting', 'takeaway'],
        servingMethod: entity.servingMethod || 'name',
        template: entity.template || 'v1',
        theme: entity.theme || 'edgy',
        distributor: entity.distributor || null,
        isDisabled: entity.isDisabled || false,
        terminalConfig: entity.terminalConfig || null,
        cashConfig: entity.cashConfig || null,
        organizationConfig: entity.organizationConfig || null,
        loyaltyProgramProvider: entity.loyaltyProgramProvider || null,
        loyaltyProgramConfig: entity.loyaltyProgramConfig || {},
        couponsProvider: entity.couponsProvider || null,
        paymentProviders: entity.paymentProviders || [],
        customerTypes: entity.customerTypes || null,
        note: entity.note || '',
        flow: entity.flow || 'catalog',
        supportMinimizeMode: entity.supportMinimizeMode === null ? true : entity.supportMinimizeMode,
        plugins: entity.plugins || {}
    };
};
